module.exports = __webpack_public_path__ + "static/media/ruffel.6f1edd7f.png";